const INTEGRATION_DISPLAY_NAMES: Record<string, string> = {
  FlashApi: "Flash",
  CardLogger: "Card",
};

const VEHICLE_INTEGRATION_DISPLAY_NAMES: Record<string, string> = {
  FlashApi: "Flash LPR",
};

const INTEGRATION_DESCRIPTIONS: Record<string, string> = {
  CardLogger:
    "Logs physical card credentials for reporting only. Does not interact with gate technology.",
};

export function getIntegrationDisplayName(
  name: string | null | undefined
): string {
  if (!name) return "";
  return INTEGRATION_DISPLAY_NAMES[name] ?? name;
}

export function getVehicleIntegrationDisplayName(
  name: string | null | undefined
): string {
  if (!name) return "";
  return VEHICLE_INTEGRATION_DISPLAY_NAMES[name] ?? getIntegrationDisplayName(name);
}

export function getIntegrationDescription(
  name: string | null | undefined
): string | null {
  if (!name) return null;
  return INTEGRATION_DESCRIPTIONS[name] ?? null;
}
